module.exports = __webpack_public_path__ + "242b8e15e79dbbc4865715c3e5759905.woff";


//////////////////
// WEBPACK FOOTER
// ./static/EuclidCircularA-Medium-WebXL.woff
// module id = 215
// module chunks = 0